import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { InputField } from "../../components/_input/_input";
import PhoneDropDown from "../../components/_input/_phoneDropDown";
import { TextArea } from "../../components/_input/_textArea";
import { DropDownInput } from "../../components/_input/_dropdown";
import { FormButton } from "../../components/_input/_button";
// import CarFeature from "../../components/carFeature";
import Breadcrumb from "../../components/__simple/breadcrumb";
import axios from "axios";
import config from '../../configuration/config';
import Joi from "joi";
import { groupBy, mapValues, omit } from "lodash";
import { GetMessages, formValidate } from '../../utils/validation';
import { toast } from "react-toastify";
import { useHistory, useLocation } from "react-router";
import { uniqBy } from "lodash";
import { getData, User_Data_Key } from "../../utils/localStorageManager";
import dropDownResetter from "../../utils/resetDropDown";
import * as journifyTrackingCarEvents from "../../services/trackingCarEvents";
export function OrderCarPage() {
    const { t: trans, i18n } = useTranslation(["heading", "finance", "form", "model", "inputs", "info", "eparts"]);
    let lang = (i18n.language || 'ar');
    const [referrer, setReferrer] = useState('');
    const [error, setError] = useState({});
    const [successData, setSuccessData] = useState(false);
    const [banner, setbanner] = useState([]);
    const [product, setproduct] = useState(null);
    const [requestForm, setRequestForm] = useState({
        name: '',
        custType: "G4",
        identityNo: '',
        cn: '',
        address: '',
        email: '',
        phoneNumber: '',
        quantity: 1,
        message: '',
        note: '',
        selectedProduct: '',
        selectedModel: '',
        selectedColor: ''
    });
    const [showProductSection, setShowProductSection] = useState(true);
    const [brands, setBrands] = useState([]);
    const [brand, setBrand] = useState(null);
    const [group, setGroup] = useState(null);
    const [type, setType] = useState(null);
    const [year, setYear] = useState(null);
    const [fColors, setFColors] = useState([]);
    //--------------------------------------------------- 
    const [fProductGroups, setFProductGroups] = useState([]);
    const [productGroups, setProductGroups] = useState([]);
    const [products, setProducts] = useState([]);
    const [fProducts, setFProduct] = useState(null);
    const [fModels, setFModels] = useState([]);
    //---------------------------------------------------
    const [supportedColors, setSupportedColors] = useState([]);
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedObjectColor, setSelectedObjectColor] = useState(null);
    //---------------------------------------------------
    const [isLoading, setIsLoading] = useState(false);
    //---------------------------------------------------
    const [vehicleInfo, setVehicleInfo] = useState(null);
    //-------------- other declaration------------------
    const [defultMobile, setDefultMobile] = useState("");
    const schema = Joi.object({
        name: Joi.string().required().messages(GetMessages()),
        address: Joi.string().messages(GetMessages()),
        email: Joi.string().email({ minDomainSegments: 2, tlds: { allow: false } }).messages(GetMessages()),
        phoneNumber: Joi.string().min(12).required().messages(GetMessages()),
        quantity: Joi.number().min(1).required().messages(GetMessages()),
        // selectedProduct: Joi.string().required().messages(GetMessages()),
        selectedModel: Joi.string().required().messages(GetMessages()),
        custType: Joi.string().required().messages(GetMessages()),
    });

    const schemaidentityNo = Joi.object({
        identityNo: Joi.string().min(10).required().messages(GetMessages()),

    });
    const schemacn = Joi.object({
        cn: Joi.string().min(10).required().messages(GetMessages()),

    });
    // declarations ver that using in route & searching in url
    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    //------------------------------------------------------
    const [userTypeList, setUserTypeList] = useState([]);
    const [userType, setUserType] = useState("");
    const [identityType, setIdentityType] = useState(1);

    const [cnValue, setCnValue] = useState("");
    const [identityValue, setIdentityValue] = useState("");
    // ------------
    useEffect(() => {

        initialBanner();
        getAllUserType();
        handleFilterModelsByProduct();
        getAllGroups();
        getAllBrands();
        getAllProducts();

        // Get the referrer information
        var ref = document.referrer;

        console.log("referrer>>>>>>>>>>>>>>>>>>>>>>>>>>:", ref);
        const params = new URLSearchParams(window.location.search);
        //  const utmSource = params.get('utm_source');
        //  console.log("utmSource>>>>>>>>>>>>>>>>>>>>>>>>>>:",utmSource);

        //  if(ref ==null){
        //     ref =utmSource;
        //  }

        if (!ref) {
            ref = window.location.origin;
        }
        console.log("referrer final >>>>>>>>>>>>>>>>>>>>>>>>>>:", ref);
        setReferrer(ref);

    }, []);

    //----------------------
    const [selectcity, setSelectcity] = useState(null);
    const [filteredCities, setFilteredCities] = useState([]);
    useEffect(async () => {
        try {
            const settingsResponse = await axios.request({
                baseURL: config.controllURL,
                url: lang + "/api/user/getSettings",
                method: "get",
            });

            if (settingsResponse.status === 200) {
                var mm = settingsResponse?.data?.genders.map(e => {
                    return { value: String(e.id), text: e.description }
                });


                setFilteredCities(settingsResponse?.data?.cities?.filter(item => {
                    return item.code == "SAU"
                }));

            }


        } catch (err) {
            console.log(err);
        }
    }, []);
    useEffect(() => {

        let result = formValidate(schema, requestForm) ?? {};

        // ex:
        // const mergedObj = Object.assign({}, obj1, obj2);
        if (identityType && identityType == 1) {
            const result22 = formValidate(schemaidentityNo, requestForm) ?? {};
            result = { ...result, ...result22 }

        } else {

            const result33 = formValidate(schemacn, requestForm) ?? {};
            result = { ...result, ...result33 }

        }
        if (Object.keys(result).length == 0) {
            setSuccessData(true);
        } else {
            setSuccessData(false);
        }
    }, [requestForm]);
    useEffect(() => {
        let data = {};

        const val = { ...requestForm };

        try {
            data = JSON.parse(getData(User_Data_Key, true));
            console.log("_userData:", data);

            console.log("requestForm:", val);
            val.name = lang == "ar" ? (data?.arFirstName ?? "") + " " + (data?.arMiddleName ?? "") + " " + (data?.arLastName ?? "") : (data?.enFirstName ?? "") + " " + (data?.enMiddleName ?? "") + " " + (data?.enLastName ?? "");
            val.address = data?.address ?? "";
            val.phoneNumber = data?.phone ?? "";
            val.identityNo = data?.identity ?? "";
            val.cn = data?.tradeNo ?? "";
            val.custType = data?.custGroupId ?? "G4";

            setIdentityValue(data?.identity ?? "");
            setCnValue(data?.tradeNo ?? "");

            if (val.custType === "G4") {
                setIdentityType(1);
            } else if (val.custType === "G3") {
                setIdentityType(2);
            }

            console.log("phone>>>>>>>>>>>>:", data?.phone?.replace(/\D/g, '').slice(-9).toString());
            if (data?.phone)
                setDefultMobile(data?.phone.replace(/\D/g, '').slice(-9).toString());
            val.email = data?.email ?? "";

            console.log("val:", val);
        } catch (error) {
            console.log("Error loading user data:", error);
        }


        const productID = query.get('vehicle');
        const typeID = query.get('type');
        const model = query.get('model');
        const color = query.get('color');
        if (productID) {

            val.selectedProduct = String(productID);
            val.selectedModel = String(model);
            val.selectedColor = String(color);
            val.selectedTypeID = String(typeID);
            setproduct(val);
            if (model) {
                handleShowVehicleDetails(productID, model);
            }
            setRequestForm(val);
            setShowProductSection(false);
            setType(typeID);
            handleFetchColors(typeID, model, color);
        }

        if (color)
            setSelectedColor(color);

        fetchCarDesign(color, productID, model);
        setRequestForm(val);
    }, []);

    useEffect(() => {

        if (products && products.length > 0 && product && product.selectedTypeID && fProducts == null) {

            var GroupID = null;

            const filteredProducts = products.filter(e => e.productTypeID == product.selectedTypeID);

            if (filteredProducts[0])
                GroupID = filteredProducts[0].productGroupID;

            if (GroupID) {
                const filteredProductsbyGroupID = products.filter(e => e.productGroupID == GroupID && e.Model == product.selectedModel);
                setFProduct(filteredProductsbyGroupID.map(product => {
                    return { value: product.productTypeID, text: product[`${trans("model:gamelDescription")}`], ...product }
                }));

                setGroup(GroupID);
            } else {
                setFProduct([]);
            }


        }

    }, [product, products, fProducts]);
    //----------------Functions + Methods------------------------
    // fetch all brands from db
    const getAllBrands = () => {
        axios.post(
            `${config.controllURL}${lang}/api/Pages/DetailsInvBrands`,
            {
                "ObjectSettings": {
                    "MetaData": false
                },
                "option": "column",
                "Fields": "BrandID,DescriptionAr,DescriptionEn",
                "filters": " where IsEnabled =1"
            }
        ).then(response => {
            const result = response.data.ApiObjectData;
            setBrands(result.map(brand => {
                return {
                    value: brand.BrandID, text: brand[`${trans("model:description")}`]
                }
            }));
        }).catch(err => {
            console.log(err);
        });
    };
    //It's used to intialize the banner
    const initialBanner = () => {
        axios.post(
            `${config.controllURL}${lang}/api/Pages/DetailssitePageBanners`,
            {
                "ObjectSettings": {
                    "MetaData": false
                },
                "filters": "where bannerId=9"
            }
        ).then(response => {
            setTimeout(setbanner(response.data.ApiObjectData), 500);
        }).catch(err => {
            console.log(err);
        });
    };
    // It's used to filter the groups by brand
    const filterModel = (option) => {

        setVehicleInfo(null);
        setSelectedColor(null);
        setType(null);
        setGroup(null);
        if (option.value == '0') {
            dropDownResetter(() => {
                setFProductGroups();
                setFModels([]);
                setFProduct([]);
                setFColors([]);
            });
        }
        setBrand(option.value);
        const fGroups = productGroups.filter(a => a.BrandID == option.value);
        setFProductGroups(fGroups.map(group => {
            return {
                value: group.ProductGroupID, text: group[`${trans("model:description")}`]
            }
        }));
    };
    // Fetch all groups
    const getAllGroups = () => {

        axios.request({
            baseURL: config.controllURL,
            url: lang + "/api/Vehicles/AvailableGroupsOnSite",
            method: "get",
        })
            .then(function (response) {
                setProductGroups(response.data);

                const uniqueGroups = Array.from(
                    new Map(response?.data?.map(item => [item.ProductGroupID, item])).values()
                );

                setProductGroups(uniqueGroups);



            })
            .catch(function (error) {
                console.log(error);
            });
    };

    // * siteGetCustGroupsforOrder
    const getAllUserType = () => {
        axios.post(
            `${config.controllURL}${lang}/api/Pages/siteGetCustGroupsforOrder`,
            {}
        ).then(response => {
            setUserTypeList(response.data);
        }).catch(err => {
            console.log(err);
        })
    };


    const handleCustType = (option) => {
        const val = { ...requestForm };
        val.custType = option;
        setRequestForm(val);
        console.log(userType);
        setUserType("");

        setCnValue("");
        setIdentityValue("");

        try {
            if (option == '' || option == null || option == '0') {
                setIdentityType(null);
                return;
            }

            // const currentValue = accountTypes.find(item => {
            //     return item.ID == option
            // }) ?? {};

            let value = null;
            if (option == "G4") {
                value = 1;
                val.cn = null;
                setUserType(val.cn);
            } else {
                value = 2;
                val.identityNo = null;
                setUserType(val.identityNo);
            }

            setRequestForm(val);
            setIdentityType(value);

        } catch (err) {
            //////console.log(err);
        }
    };


    //Fetch all products
    const getAllProducts = () => {
        // SiteFetchAvailableCarsOnSite
        // axios.post(
        //     config.baseURL + "func",
        //     {
        //         "Name": "SiteFetchALLProductModelTypesOnSite",
        //     }
        // ).then(response => {
        //     const result = response.data;
        //     setProducts(result);
        // }).catch(err => {
        //     console.log(err);
        // });


        axios.request({
            baseURL: config.controllURL,
            url: lang + "/api/Vehicles/ALLProductModelTypesOnSite",
            method: "get",
        })
            .then(function (response) {
                setProducts(response.data);


            })
            .catch(function (error) {
                console.log(error);
            });

    };
    // to get the model of the product
    const handleFilterModelsByProduct = () => {
        axios.post(
            `${config.controllURL}${lang}/api/Pages/DetailsInvProductModel`,
            {
                "ObjectSettings": {
                    "MetaData": false,
                },
                "Option": "Column",
                "Fields": "modelID",
                "Filters": `where  modelID >='2015' `
            }
        ).then(response => {
            const result = response.data.ApiObjectData;
            const models = result.map(item => {
                return item.modelID
            });
            const uniqueModels = uniqBy(models, (mY) => {
                return mY;
            }).filter((value) => {
                return value !== null
            }).map(item => {
                return { text: item, value: item }
            });
            setFModels(uniqueModels);
        }).catch(err => {
            console.log(err);
        });
    }
    //Filter the products by group
    const filterProductsByGroup = (option) => {
        setType(null);
        setGroup(null);
        setVehicleInfo(null);
        setSelectedColor(null);
        if (option.value == '0') {
            dropDownResetter(() => {
                setFProduct([]);
                setFModels([]);
            });
        }
        setGroup(option.value);
        const filteredProducts = products.filter(e => e.productGroupID == option.value && e.Model == requestForm.selectedModel);
        setFProduct(filteredProducts.map(product => {
            return { value: product.productTypeID, text: product[`${trans("model:gamelDescription")}`], ...product }
        }));
    };
    const handleSendRequest = async () => {

        if (isLoading == true)
            return;

        let result = formValidate(schema, requestForm) ?? {};

        // ex:
        // const mergedObj = Object.assign({}, obj1, obj2);
        if (identityType && identityType == 1) {
            const result22 = formValidate(schemaidentityNo, requestForm) ?? {};
            result = { ...result, ...result22 }

        } else {

            const result33 = formValidate(schemacn, requestForm) ?? {};
            result = { ...result, ...result33 }

        }
        setError(result);

        if (Object.keys(result).length == 0) {
            if (supportedColors?.length > 0 && selectedColor == null) {
                toast.error(trans("finance:color_not_select"));
                setIsLoading(false);
                return;
            }
            setIsLoading(true);
            const basicInfo = await getMainUserData();

            const objectColor = fColors.filter(c => c.value == selectedColor)[0]
            if (!objectColor) {

            }


            var raw = {
                "Name": requestForm.name,
                "Phone": requestForm.phoneNumber,
                "Email": requestForm.email,
                "Address": requestForm.address,
                "Quantity": Number(requestForm.quantity),
                "ColorID": (selectedColor != null || selectedColor != '') ? String(selectedColor) : null,
                "ColorGroupID": objectColor ? objectColor.ColorGroupID : null,
                "BrandID": objectColor ? objectColor.BrandID : null,
                "ProductGroupID": objectColor ? objectColor.ProductGroupID : null,
                "Web_UserID": basicInfo ? Number(basicInfo.userId) : null,
                "CustID": basicInfo ? basicInfo.custId ? String(basicInfo.custId) : null : null,
                "ProductTypeID": requestForm.selectedTypeID,
                "ModelYear": requestForm.selectedModel,
                "CustGroupID": requestForm.custType,
                "AddtionalNo": identityValue ?? cnValue ?? "",
                "Note": (requestForm?.note ?? ""),
                "ReferrerBy": (referrer ? referrer : "")
            };

            console.log("raw>>>>>>>>>>>>>>>>:", raw);

            // return;
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            await axios.request({
                baseURL: config.controllURL,
                url: "api/Payment/AddOrderPurchaseVehicle",
                headers: myHeaders,
                data: raw, method: "POST", responseType: "json"
            })
                .then(response => {

                    //-------------------------------
                    journifyTrackingCarEvents.trackGenerateLead(objectColor?.NetSalePrice ?? 0);


                    toast.success(trans("common:order-request-success"));
                    setIsLoading(false);
                    history.push("/");
                }).catch(err => {
                    toast.error(trans("finance:error_send_data"));
                    setIsLoading(false);

                    //  toast.success(trans("common:order-request-success"));
                    // setIsLoading(false);
                    // history.push("/");
                });

        }
    };
    // get the main essetional info about user [web_user_id & cust_id]
    const getMainUserData = async () => {
        let data = null;
        try {
            const _data = JSON.parse(getData(User_Data_Key, true));
            if (localStorage.getItem("isAuthenticated")) {
                data = {
                    userId: Number(_data.id.toString().split('_')[1]),
                    custId: _data.custID
                };
            } else {
                const response = await axios.post(
                    `${config.controllURL}${lang}/api/Pages/Detailsweb_users`,
                    {
                        "Option": "Column",
                        "ObjectSettings": {
                            "MetaData": false,
                            "Limit": {
                                "Value": 1,
                                "Optional": "Top"
                            }
                        },
                        "Fields": "Web_UserId,CustID",
                        "Filters": `where lower(email) = lower('${requestForm.email}')`
                    }
                );
                if (response.status == 200) {
                    const result = response.data.ApiObjectData;
                    if (result.length > 0) {
                        const finalResult = result[0];
                        data = {
                            userId: finalResult.Web_UserId,
                            custId: finalResult.CustID
                        };
                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
        return data;
    };
    const handleFetchColors = (productTypeID, modelYear, defultColor) => {

        if (productTypeID != '' && modelYear != '') {
            axios.post(
                `${config.controllURL}${lang}/api/Pages/site_fetchColorOfType`,
                {
                    "Type": productTypeID,
                    "model": modelYear
                }
            ).then(response => {

                const uniquefilterColors = Array.from(
                    new Map(response?.data?.map(item => [item.ColorID, item])).values()
                );

                const filterColors = uniquefilterColors?.map((item) => {
                    return {
                        text: (lang == "ar" ? item?.ColorDescriptionAr : item?.ColorDescriptionEn),
                        value: item.ColorID, ...item
                    }
                });
                setFColors(filterColors);

                if (defultColor) {
                    setSelectedColor(defultColor);
                } else {

                    if (filterColors && filterColors[0]) {
                        setSelectedColor(filterColors[0].value);
                    }
                }
                if (response.data[0])
                    handleShowVehicleDetails(response.data[0].ProductID, modelYear);
            }).catch(error => {
                console.log(error);
            })


        }
    };
    //Show the vehicle details[image-features]
    const handleShowVehicleDetails = (productID, model) => {
        axios.post(
            `${config.controllURL}${lang}/api/Pages/SiteGetMoreCarInfo`,
            {
                "productID": `${productID}`,
                "model": `${model}`
            }
        ).then(response => {
            setVehicleInfo(response.data[0]);
        }).catch(err => {
            console.log(err);
        })
    };



    const [cashCarImages, setCashCarImages] = useState({});
    const [outerCarImagesJson, setOuterCarImagesJson] = useState(null);
    const [isLoadingImages, setIsLoadingImages] = useState(false);
    const fetchCarDesign = async (activeColor, model, year) => {

        // console.log("activeColor>>>>>>>>>>>>>>>>>>>>>>>>>:", activeColor);
        // console.log("model>>>>>>>>>>>>>>>>>>>>>>>>>:", model);
        if (isLoadingImages == false) {

            const Namefiled = "frontImage,leftImage,backImage,sideImage,rightImage,mainColorImage"

            const prefix = 'data:image/png;base64,';
            if (model) {
                if (cashCarImages[model + "-part-" + 0]) {
                    setIsLoadingImages(false);
                    var AllCarImagesOUT = cashCarImages[model + "-part-" + 0];
                    setOuterCarImagesJson(AllCarImagesOUT);

                } else {
                    axios.post(
                        `${config.controllURL}${lang}/api/Pages/SiteFetchCarColorCodeImages`,
                        {
                            "Id": model,
                            "year": year,
                            // "ColorID": String(codeColor),
                            "ColorID": null,
                            "FieldNameList": null
                        }
                    ).then(response => {
                        setIsLoadingImages(false);
                        var maincolorimageIndex = 0;
                        // console.log("SiteFetchCarColorCodeImages responseData>>>>>>>>>>>>>>>>>>>>>>>>>:", response.data);
                        if (Array.isArray(response.data)) {
                            const responseData = response.data;
                            const groupResult = mapValues(groupBy(responseData, 'ColorCode'), fList => fList.map(items => omit(items, 'ColorCode')));

                            // console.log("responseData groupResult>>>>>>>>>>>>>>>>>>>>>>>>>:", groupResult);
                            setOuterCarImagesJson(groupResult);
                            cashCarImages[model + "-part-" + 0] = groupResult;
                            setCashCarImages(cashCarImages);
                            setIsLoadingImages(false);

                        }
                    }).catch(error => {
                        // console.log(error);
                        setIsLoadingImages(false);
                        // cashCarImages[model + "-part-" + 0] = {};
                    });

                }

            }
        }
    };

    return (
        <div className={`order-car-page ${lang === 'ar' ? 'i18n-rtl' : ''}`}>
            <Helmet>
                <title>{trans("finance:veh-order")} {vehicleInfo ? "- " + (lang === 'ar' ? vehicleInfo.brand : vehicleInfo.brandEn) : ""}</title>
                <meta name="description" content={`${trans("form:send-order-for")} ${vehicleInfo ? (lang === 'ar' ? vehicleInfo.brand : vehicleInfo.brandEn) : trans("eparts:vehicle")}`} />
                <link rel="canonical" href={window.location.href} />
                <meta property="og:title" content={`${trans("finance:veh-order")} ${vehicleInfo ? "- " + (lang === 'ar' ? vehicleInfo.brand : vehicleInfo.brandEn) : ""}`} />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className="ctn">
                <Breadcrumb className={"pt-12 mb-8 "}
                    links={[
                        {
                            name: trans("finance:veh-order"),
                        },
                    ]}
                />

                <div className="stag">  {trans("form:send-order-for")} <span className="gn">{vehicleInfo ? (lang === 'ar' ? vehicleInfo.brand : vehicleInfo.brandEn) : trans("eparts:vehicle")}</span>
                </div>


                <div className="order-form-grid">
                    {/* Form Side */}
                    <div className="flex flex-col gap-8">
                        {/* User Identity Card */}
                        <div className="form-card" tabIndex={0}>
                            <h3 className="form-section-title">{trans("info:user_info")}</h3>
                            <div className="grid-2-cols nice-gap-2rem">
                                <div>
                                    <InputField
                                        extraClasses={"Input-module"}
                                        placeholder={trans("form:name")}
                                        moduleLabel={trans("form:name")}
                                        value={requestForm.name}
                                        errorLabel={error?.name}
                                        onChangeValue={(e) => {
                                            const val = { ...requestForm };
                                            val.name = e.target.value;
                                            setRequestForm(val);
                                        }}
                                        name='name'
                                    />
                                </div>
                                <div>
                                    <PhoneDropDown
                                        placeholder={trans("form:phone")}
                                        moduleLabel={trans("form:phone")}
                                        extraClasses={"phone-Input-module"}
                                        errorLabel={error?.phoneNumber}
                                        defaultValue={defultMobile}
                                        onChangeValue={
                                            (key, value) => {
                                                const val = { ...requestForm };
                                                val.phoneNumber = `+${key}${value}`;
                                                setRequestForm(val);
                                            }
                                        }
                                    />
                                </div>
                            </div>
                            <div className="grid-2-cols nice-gap-2rem mt-12">
                                <div>
                                    <DropDownInput
                                        placeholder={trans("new:city")}
                                        title={trans("new:city")}
                                        errorLabel={error.address}
                                        extraClasses={"dropdown-Input-module"}
                                        selectedValue={requestForm.City}
                                        options={[...filteredCities?.map(item => {
                                            return { text: item?.description, value: item?.id, optional: item?.code }
                                        })]}
                                        onfilter={(Citey) => {
                                            const val = { ...requestForm };
                                            val.City = Citey.value;
                                            val.address = Citey.text;
                                            setRequestForm(val);
                                        }}
                                        isepart={true}
                                    />
                                </div>
                                <div>
                                    <InputField
                                        value={requestForm.email}
                                        extraClasses={"Input-module"}
                                        placeholder={trans("form:email")}
                                        moduleLabel={trans("form:email")}
                                        type='email'
                                        onChangeValue={(e) => {
                                            const val = { ...requestForm };
                                            val.email = e.target.value;
                                            setRequestForm(val);
                                        }}
                                        errorLabel={error?.email}
                                        name='email'
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Applicant & Vehicle Details Card */}
                        <div className="form-card" tabIndex={0}>
                            <h3 className="form-section-title">{trans("finance:details")}</h3>
                            <div className="grid-2-cols nice-gap-2rem">
                                <div>
                                    <DropDownInput
                                        extraClasses={"dropdown-Input-module"}
                                        placeholder={trans("finance:applicant")}
                                        title={trans("finance:applicant")}
                                        defaultOption={
                                            (requestForm?.custType == null || requestForm?.custType == "")
                                                ? { text: trans("finance:applicant"), value: '0' }
                                                : null}
                                        errorLabel={error?.custType}
                                        options={[...userTypeList.map(item => {
                                            return { text: lang == "ar" ? item.DescriptionAr : item.DescriptionEn, value: item.ID }
                                        })]}
                                        onSelect={handleCustType}
                                        selectedValue={requestForm.custType}
                                        isepart={true}
                                    />
                                </div>

                                {requestForm?.custType != null && (
                                    <div>
                                        <InputField
                                            extraClasses={"Input-module"}
                                            placeholder={(identityType && identityType == 1)
                                                ? trans("form:identity-no")
                                                : (identityType === 2) ? trans("finance:cn") : trans("form:identity-no")}
                                            moduleLabel={(identityType && identityType == 1)
                                                ? trans("form:identity-no")
                                                : (identityType === 2) ? trans("finance:cn") : trans("form:identity-no")}
                                            errorLabel={(identityType && identityType == 1)
                                                ? error?.identityNo
                                                : (identityType == 2) ? error?.cn : error?.identityNo
                                            }
                                            value={(identityType && identityType == 1)
                                                ? identityValue
                                                : (identityType == 2) ? cnValue : identityValue
                                            }
                                            length={10}
                                            onChangeValue={(e) => {
                                                const val = { ...requestForm };
                                                if (identityType && identityType == 1) {
                                                    val.identityNo = e.target.value;
                                                    setIdentityValue(e.target.value);
                                                } else {
                                                    val.cn = e.target.value;
                                                    setCnValue(e.target.value);
                                                }
                                                setRequestForm(val);
                                            }}
                                        />
                                    </div>
                                )}
                            </div>

                            {showProductSection && (
                                <div className="flex flex-col gap-4">
                                    <div className="grid-2-cols nice-gap-2rem">
                                        <div>
                                            <DropDownInput
                                                extraClasses={"dropdown-Input-module"}
                                                placeholder={trans("info:company")}
                                                title={trans("info:company")}
                                                defaultOption={(brand == '0' || brand == null) ? {
                                                    text: trans("info:company"),
                                                    value: '0'
                                                } : null}
                                                onfilter={filterModel}
                                                options={[...brands]}
                                                selectedValue={brand}
                                                isepart={true}
                                            />
                                        </div>
                                        <div>
                                            <DropDownInput
                                                placeholder={trans("info:created_year")}
                                                title={trans("info:created_year")}
                                                extraClasses={"dropdown-Input-module"}
                                                selectedValue={year}
                                                errorLabel={error?.selectedModel}
                                                defaultOption={{
                                                    text: trans("info:created_year"),
                                                    value: '0'
                                                }}
                                                options={[...fModels]}
                                                onSelect={
                                                    (e) => {
                                                        const val = { ...requestForm };
                                                        val.selectedModel = String(e);
                                                        setYear(e);
                                                        setRequestForm(val);
                                                        setVehicleInfo(null);
                                                        setSelectedColor(null);
                                                        handleFetchColors(val.selectedProduct, e);
                                                    }
                                                }
                                                isepart={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="grid-2-cols nice-gap-2rem">
                                        <div>
                                            <DropDownInput
                                                placeholder={trans("eparts:vehicle")}
                                                title={trans("eparts:vehicle")}
                                                selectedValue={group}
                                                extraClasses={"dropdown-Input-module"}
                                                defaultOption={((brand == '0' || brand == null) || (group == '0' || group == null)) ? {
                                                    text: trans("eparts:vehicle"),
                                                    value: '0'
                                                } : null}
                                                options={[...fProductGroups]}
                                                onfilter={filterProductsByGroup}
                                                isepart={true}
                                            />
                                        </div>
                                        <div>
                                            <DropDownInput
                                                selectedValue={type}
                                                placeholder={trans("eparts:model")}
                                                title={trans("eparts:model")}
                                                extraClasses={"dropdown-Input-module"}
                                                errorLabel={error?.selectedProduct}
                                                defaultOption={((brand == '0' || brand == null) || (group == '0' || group == null)) ? {
                                                    text: trans("eparts:model"),
                                                    value: '0'
                                                } : null}
                                                options={fProducts ? [...fProducts] : []}
                                                onfilter={
                                                    (e) => {
                                                        if (e.value == '0') {
                                                            dropDownResetter(() => {
                                                                setFModels([]);
                                                                setFColors([]);
                                                            });
                                                            return;
                                                        }
                                                        const val = { ...requestForm };
                                                        val.productTypeID = String(e.value);
                                                        setType(val.productTypeID);
                                                        setRequestForm(val);
                                                        setVehicleInfo(null);
                                                        setSelectedColor(null);
                                                        handleFetchColors(e.productTypeID, val.selectedModel);
                                                    }
                                                }
                                                isepart={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="grid-2-cols nice-gap-2rem" tabIndex={0}>
                                {fColors.length > 0 && (
                                    <div>
                                        <DropDownInput
                                            placeholder={trans("info:avaliable_colors")}
                                            title={trans("info:avaliable_colors")}
                                            extraClasses={"dropdown-Input-module"}
                                            selectedValue={selectedColor}
                                            defaultOption={{
                                                text: trans("info:avaliable_colors"),
                                                value: '0'
                                            }}
                                            onSelect={(option) => {
                                                setSelectedColor(option);
                                                const objectColor = fColors.filter(c => c.value == option)[0]?.ProductID;
                                                fetchCarDesign(option, objectColor, requestForm.selectedModel);
                                            }}
                                            options={[...fColors]}
                                            isepart={true}
                                        />
                                    </div>
                                )}
                                <div>
                                    <InputField
                                        extraClasses={"Input-module"}
                                        placeholder={trans("finance:quantity")}
                                        moduleLabel={trans("finance:quantity")}
                                        value={requestForm?.quantity}
                                        type='number'
                                        onChangeValue={(e) => {
                                            const val = { ...requestForm };
                                            val.quantity = e.target.value;
                                            setRequestForm(val);
                                        }}
                                        errorLabel={error?.quantity}
                                        name='quantity'
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Note Card */}
                        <div className="form-card" tabIndex={0}>
                            <h3 className="form-section-title">{trans("finance:note")}</h3>
                            <TextArea
                                placeholder={""}
                                moduleLabel={trans("finance:note")}
                                extraClasses={"Textarea-module"}
                                value={requestForm?.note}
                                onChangeValue={
                                    (e) => {
                                        const val = { ...requestForm };
                                        val.note = e;
                                        setRequestForm(val);
                                    }
                                }
                                name='note'
                                row={3}
                            />
                        </div>
                    </div>

                    {/* Visual Side */}
                    <div className="car-display-card">
                        {vehicleInfo ? (
                            <>
                                <div className="car-info">
                                    <div className="car-badge">{lang === 'ar' ? vehicleInfo?.brand : vehicleInfo?.brandEn}</div>
                                    <h2>{lang === 'ar' ? vehicleInfo?.ModelTypes : vehicleInfo?.ModelTypesEn}</h2>
                                    {/* Removed car description label as requested */}
                                </div>

                                <div className="mt-16 relative h-64 flex items-center justify-center">
                                    {outerCarImagesJson &&
                                        outerCarImagesJson[selectedColor?.split("/")[0]] ?
                                        <img className={"car-float-img"} src={config.FilePathURL + outerCarImagesJson[selectedColor?.split("/")[0]][0]?.Image_URL} alt="car" />
                                        :
                                        <div className="text-gray-400 opacity-20">
                                            <svg width="160" height="160" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9C2.1 11.1 2 11.5 2 12v4c0 .6.4 1 1 1h2" /><circle cx="7" cy="17" r="2" /><path d="M9 17h6" /><circle cx="17" cy="17" r="2" /></svg>
                                        </div>
                                    }
                                </div>

                                <div className="specs-grid">
                                    <div className="spec-item">
                                        <span className="spec-val">{vehicleInfo?.Petrol ?? '0'}</span>
                                        <span className="spec-lbl">{trans("vehicales:veh-petrol")}</span>
                                    </div>
                                    <div className="spec-item">
                                        <span className="spec-val">{vehicleInfo?.SeatsNumber ?? '0'}</span>
                                        <span className="spec-lbl">{trans("vehicales:veh-seat")}</span>
                                    </div>
                                    <div className="spec-item">
                                        <span className="spec-val">{vehicleInfo?.Cylinders ?? '0'}</span>
                                        <span className="spec-lbl">{trans("vehicales:veh-cle")}</span>
                                    </div>
                                    <div className="spec-item">
                                        <span className="spec-val">{vehicleInfo?.HP ?? '0'}</span>
                                        <span className="spec-lbl">{trans("vehicales:veh-eng")}</span>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="h-full flex flex-col items-center justify-center text-t3 opacity-50 py-20">
                                <div className="mb-4">
                                    <svg width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" /></svg>
                                </div>
                                <p>{trans("eparts:select_vehicle_to_view") || "Select a vehicle to view details"}</p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="submit-container">
                    <FormButton
                        isLoading={isLoading}
                        name={trans("form:send-order")}
                        disabled={!successData}
                        isPrimary={true}
                        classes="primary"
                        onClick={async () => {
                            if (isLoading == false)
                                await handleSendRequest();
                        }}
                    />
                </div>
            </div>
        </div>
    );

}